import React, { Component } from 'react';
import '../cv_img/style.css';
import uCV1 from '../../assets/img/usmanCV_1.png';
import uCV2 from '../../assets/img/usmanCV_2.png';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css'; 
import Roll from 'react-reveal/Roll';
import Zoom from 'react-reveal/Zoom';
import Flip from 'react-reveal/Flip';

const images = [
  uCV1,uCV2
];

export default class CRI extends Component {
  constructor(props) {
    super(props);
    this.state = {
      photoIndex: 0,
      isOpen: false,
    };
  }

  render() {
    const { photoIndex, isOpen } = this.state;
    return (
     
      <Roll right>
        <Zoom right> 
        <Flip right>
        <div>
          <img src={uCV1} onClick={() => this.setState({ isOpen: true })} className="cv_img_mouse" alt="Usman Arif CV preview"/>
            {isOpen && (
                <Lightbox
                  mainSrc={images[photoIndex]}
                  nextSrc={images[(photoIndex + 1) % images.length]}
                  prevSrc={images[(photoIndex + images.length - 1) % images.length]}
                  onCloseRequest={() => this.setState({ isOpen: false })}
                  onMovePrevRequest={() =>
                    this.setState({
                      photoIndex: (photoIndex + images.length - 1) % images.length,
                    })
                  }
                  onMoveNextRequest={() =>
                    this.setState({
                      photoIndex: (photoIndex + 1) % images.length,
                    })
                  }
                />
              )}
        </div>
        </Flip>
        </Zoom>
      </Roll>
     
    );
  }
}